/**
 * @fileoverview Componente responsável por renovar automaticamente o token de autenticação.
 */

import { useEffect } from 'react';
import api from '../../services/api';

/**
 * Componente que faz refresh automático do token a cada 23 horas
 * para prevenir logout quando o usuário fica inativo
 *
 * O token expira em 24h, então fazemos refresh preventivo 1h antes
 */
const AutoRefreshToken = () => {
  useEffect(() => {
    // ============================================
    // OTIMIZAÇÃO: Auto-refresh preventivo do token
    // Previne logout quando usuário fica inativo por muito tempo
    // Faz refresh a cada 23 horas (1h antes de expirar)
    // ============================================
    const REFRESH_INTERVAL = 23 * 60 * 60 * 1000; // 23 horas em ms

    const refreshToken = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        return; // Sem token, não fazer nada
      }

      try {
        const { data } = await api.post('/auth/refresh_token');

        if (data.token) {
          localStorage.setItem('token', data.token);
        }
      } catch (error) {
        // Silenciar erro - deixar interceptor do axios lidar com isso
        // Não fazer logout aqui - deixar o interceptor do axios lidar com isso
      }
    };

    // Fazer primeiro refresh após 23 horas
    const intervalId = setInterval(refreshToken, REFRESH_INTERVAL);

    // Opcional: fazer refresh também quando a tab volta a ficar ativa
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        const token = localStorage.getItem('token');
        if (token) {
          // Verificar se token está próximo de expirar
          // Se sim, fazer refresh preventivo
          refreshToken();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null; // Componente não renderiza nada
};

export default AutoRefreshToken;
